<template>
  <BaseScreen v-bind="screen">
    <BaseMenu
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import BaseMenu from '@/components/BaseMenu.vue';

export default {
  name: 'FeedbackScreen',
  mixins: [screenMixin],
  components: {
    BaseMenu,
  },
  computed: {
    titleText() {
      return this.$t('titles.feedback');
    },
    screenCase() {
      return CONSTANTS.STEP_FEEDBACK;
    },
    menuItems() {
      return [
        {
          icon: {
            name: 'microphone',
            theme: 'primary',
            size: 'l',
          },
          label: {
            text: this.$t('titles.audioFeedback'),
            size: 'm',
            isBright: true,
            isNormal: true,
          },
          action: this.goToAudioScreen,
        },
        {
          icon: {
            name: 'video',
            theme: 'primary',
            size: 'l',
          },
          label: {
            text: this.$t('titles.videoFeedback'),
            size: 'm',
            isBright: true,
            isNormal: true,
          },
          action: this.goToVideoScreen,
        },
      ];
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_RECORD_AUDIO, this.goToAudioScreen],
      [CONSTANTS.ACTION_RECORD_VIDEO, this.goToVideoScreen],
    ]);
  },
  methods: {
    goToAudioScreen() {
      this.$router.push(this.$router.options.paths.audioInstruction);
    },
    goToVideoScreen() {
      this.$router.push(this.$router.options.paths.videoInstruction);
    },
  },
};
</script>
